import { FC, useState } from 'react'
import { ChevronDownIcon } from 'lucide-react'
import { LessonType } from '../../../../types'
import { formatVideoLength } from '../../../../utils'
import { StyledCoursePreviewContentLesson } from '.'

type Props = {
  lesson: LessonType
  index: number
}

const CoursePreviewContentLesson: FC<Props> = ({ lesson, index }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <StyledCoursePreviewContentLesson>
      <button className="lesson-btn" onClick={() => setExpanded(!expanded)}>
        <div className="lesson-details-container">
          <div className="lesson-thumbnail">
            <img src={lesson.thumbnail?.fileHttpLink} alt="" />
          </div>
          <div className="lesson-details">
            <span className="lesson-label">{lesson.label || `LESSON ${index + 1}`}</span>
            <span className="lesson-title">{lesson.title}</span>
          </div>
        </div>
        <div className="lesson-actions">
          <span className="lesson-time">{formatVideoLength(lesson?.video?.duration || 0)}</span>
          {!!lesson?.offeringsDescription?.length && (
            <div className="lesson-expand-btn">
              <ChevronDownIcon style={{ transform: `rotate(${expanded ? 180 : 0}deg)` }} />
            </div>
          )}
        </div>
      </button>
      {expanded && (
        <ul className="lesson-offerings">
          {lesson.offeringsDescription?.map((offering) => {
            return <li>{offering}</li>
          })}
        </ul>
      )}
    </StyledCoursePreviewContentLesson>
  )
}

export default CoursePreviewContentLesson
